import React from "react";
import g from "glamorous";

import colors from "../utils/colors";
import generalStyles from "../utils/generalStyles";

const GhostButton = g.button(
  {
    border: `1px solid ${colors.aluminum}`,
    color: colors.aluminum,
    background: "transparent",
    height: "2rem",
    cursor: "pointer",
    transition: generalStyles.transition,
    padding: 0,
    ":hover": {
      background: colors.fiord,
      borderColor: colors.fiord,
      color: "white"
    },
    ":focus": {
      outline: "none"
    },
    ":first-child": {
      marginLeft: 0
    },
    ".selected": {
      background: colors.fiord,
      color: "white",
      cursor: "default",
      borderColor: colors.fiord
    }
  },
  props => {
    let styles = {};
    styles.width = props.width ? props.width : "auto";
    styles.marginLeft = props.marginLeft ? props.marginLeft : ".5rem";
    return styles;
  }
);

export default GhostButton;



// WEBPACK FOOTER //
// ./src/components/ghostButton.js